import CallbackPage from "../components/reuseableComponents/auth/CallbackPage";
import CreatePortalAccount from "../components/public/CreatePortalAccount";
import CypressAuth from "../components/reuseableComponents/auth/CypressAuth";
import HomePage from "../components/public/HomePage";
import NotAuthorized from "../components/reuseableComponents/auth/NotAuthorized";
import PublicPage from "../components/public/PublicIndex";
import ReportsHomePage from "../components/archive/ReportsHomePage";
import RequestPortalAccess from "../components/public/RequestPortalAccess";
import WaterSystemRedirect from "../components/public/WaterSystemRedirect";
import RequestAccess from "../components/public/RequestAccess";
import PortalAccessForm from "../components/public/PortalAccessForm";
import StaffAccessForm from "../components/public/StaffAccessForm";
import WaterSystemDetailedInfoPage from "../components/public/WaterSystemDetailedInfoPage";
import WaterMonitoringPage from "../components/public/WaterMonitoringPage";

export const publicRoutes = [
  {
    path: "/",
    component: HomePage
  },
  {
    path: "/callback",
    component: CallbackPage
  },
  {
    path: "/cypress-auth",
    component: CypressAuth
  },
  {
    path: "/public-index",
    component: PublicPage
  },
  {
    path: "/reports/:systemId",
    component: ReportsHomePage
  },
  {
    path: "/public/water-system-redirect/:action",
    component: WaterSystemRedirect
  },
  {
    path: "/public/water-system-redirect/:action/*",
    component: WaterSystemRedirect
  },
  {
    path: "/public/request-portal-access",
    component: RequestPortalAccess
  },
  {
    path: "/public/request-access",
    component: RequestAccess
  },
  {
    path: "/public/portal-access-form",
    component: PortalAccessForm
  },
  {  
    path: "/public/staff-access-form",
    component: StaffAccessForm
  },
  {
    path: "/public/staff-access-form",
    component: RequestAccess
  },
  {
    path: "/public/create-portal-account",
    component: CreatePortalAccount
  },
  {
    path: "/not-authorized",
    component: NotAuthorized
  },
  {
    path: "/home/water-system-detailedInfo",
    component: WaterSystemDetailedInfoPage
  },
  {
    path: "/home/water-monitoring",
    component: WaterMonitoringPage
  }
];
